import styled from "styled-components";
import MapComponent from "../../components/map";

type Props = {}

const Container = styled.div`
    height: 100%;
    max-height: 100%;

    .layout-box {
        margin: 0 auto;
    }

    .footer {
        padding: 4rem 0 2rem;
    }
`;

const MapPage: React.FC<Props> = () => {
    return <Container>
        <MapComponent />
    </Container>
}

export default MapPage;
